export const getGradeInArabic = (grade: string): string => {
  const gradeMap: { [key: string]: string } = {
    '1': 'الأول الثانوي',
    '2': 'الثاني الثانوي',
    '3': 'الثالث الثانوي',
    'First': 'الأول الثانوي',
    'Second': 'الثاني الثانوي',
    'Third': 'الثالث الثانوي',
    'secondary1': 'الصف الأول الثانوي',
    'secondary2': 'الصف الثاني الثانوي',
    'secondary3': 'الصف الثالث الثانوي',
    'Secondary1': 'الصف الأول الثانوي',
    'Secondary2': 'الصف الثاني الثانوي',
    'Secondary3': 'الصف الثالث الثانوي',
    '1st': 'الصف الأول الثانوي',
    '2nd': 'الصف الثاني الثانوي',
    '3rd': 'الصف الثالث الثانوي'
  };

  return gradeMap[grade] || grade;
};

// Function to get term in Arabic
export const getTermInArabic = (term: string): string => {
  const termMap: { [key: string]: string } = {
    First: 'الفصل الدراسي الأول',
    Second: 'الفصل الدراسي الثاني',
    Summer: 'الفصل الدراسي الصيفي',
    first: 'الفصل الدراسي الأول',
    second: 'الفصل الدراسي الثاني',
    summer: 'الفصل الدراسي الصيفي',
    '1': 'الفصل الدراسي الأول',
    '2': 'الفصل الدراسي الثاني',
  };

  return termMap[term] || term;
};

// Function to get recommended courses text
export const getRecommendedCoursesText = (grade: string): string => {
  return `المناهج المقترحة للصف ${getGradeInArabic(grade)}`;
};

export const courseSectionTranslations = {
  availableCourses: 'المناهج المتاحة',
  currentGrade: 'الصف الحالي',
  previous: 'السابق',
  next: 'التالي',
  noCoursesFound: 'لم يتم العثور على مناهج',
  errorLoading: 'حدث خطأ أثناء تحميل المنهج',
  featuredCourses: 'المناهج المميزة',
  discoverCourses: 'اكتشف مجموعتنا المختارة بعناية من المناهج',
  recommendedForGrade: getRecommendedCoursesText
}; 